import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { UserService } from '../services/user.service';

const ELEMENT_DATA: any[] = [
  {position: 1, path: 'RecordText1.xml', downloadURL: 'https://firebasestorage.googleapis.com/v0/b/patient-record-system-5e932.appspot.com/o/record%2F1607210110416_vectorImage.png?alt=media&token=a8f1b997-a9ea-4744-9be1-df4e85f342ef'},
  {position: 2, path: 'Yearly_Checkup.png', downloadURL: 'https://firebasestorage.googleapis.com/v0/b/patient-record-system-5e932.appspot.com/o/record%2F1607210110416_vectorImage.png?alt=media&token=a8f1b997-a9ea-4744-9be1-df4e85f342ef'},
  {position: 3, path: 'Nutrition_Check.xml', downloadURL: 'https://firebasestorage.googleapis.com/v0/b/patient-record-system-5e932.appspot.com/o/record%2F1607210110416_vectorImage.png?alt=media&token=a8f1b997-a9ea-4744-9be1-df4e85f342ef'}
];

const PATIENT_DATA: any[] = [
  {position: 1, name: 'Angelina Tsuboi', records: 1},
  {position: 2, name: 'Jane Doe', records: 4},
  {position: 3, name: 'Markus Kyle', records: 6}
];

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {
  name: String = "";
  role: String = "";  
  displayedColumns: string[] = ['position', 'downloadURL', 'path'];
  patientDisplayedColumns: string[] = ['position', 'name', 'records'];
  records = [];
  dataSource = ELEMENT_DATA;
  patientDataSource = PATIENT_DATA;
  constructor(public userService: UserService, private afs: AngularFirestore, private changeDetectorRefs: ChangeDetectorRef) { 
    this.name = userService.currentUser.name;
    this.role = userService.currentUser.role;
    console.log(userService.currentUser)
    // if(this.role != 'doctor'){
    //   this.getPatientRecords().then(() => {
    //     this.dataSource = this.records;
    //     this.changeDetectorRefs.detectChanges();
    //   });
    // }
  }

  ngOnInit(): void {
  }

  async getPatientRecords(){
    this.records = []
    this.afs.firestore.collection("patients").doc(this.userService.currentUser.uid.toString()).get().then((docRef) => {
      this.dataSource = [];
      let count = 1;
      docRef.data().records.forEach((record) => {
        this.afs.firestore.collection("records").where('path', '==', record).get().then((querySnapshot) => {
          querySnapshot.forEach((docRefData) => {
            this.records.push({path: docRefData.data().path, downloadURL: docRefData.data().downloadURL, position: count});
            count++;
          });
        })
      });
      console.log(this.records);
    });
  }

}
